<template>
  <div>
    <div class="container log_or_reg_main" v-if="!buttonPress">
      <Welcome
        :text_colour="invitation?.campaign?.text_colour"
        :elem_colour="invitation?.campaign?.elem_colour" 
        :public_name="invitation?.campaign?.public_name"
      />
      <CampaignConnect 
        :campaign="invitation?.campaign" 
        mode="small"
        @toggleViewSize="toggleFocus"
        @connectPress="connectPress"
      />
      <CampaignConnect 
        v-if="showBigCampaign" 
        class="campaign-connect-fullscreen"
        :campaign="invitation?.campaign"
        mode="big"
        @toggleViewSize="toggleFocus"
        @connectPress="connectPress"
      />
    </div>
    <div v-else class="card">
      <router-link :to="{ name: 'game-login' }">
        <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
      </router-link>
      <div class="block">
        <h2>Bienvenue chez Yuzu</h2>
        <p>
          <span class="primary-color bold">{{
            invitation?.campaign?.public_name
          }}</span
          > vous invite à rejoindre sa campagne Yuzu. Accédez à votre aventure et découvrez vos soft skills !"
        </p>
      </div>
      <transition name="fade" mode="out-in">
        <div v-if="!state.showLoginForm" class="block">
          <div class="container">
            <div class="btn-group">
              <Button
                class="light outline full-size"
                label="S'inscrire"
                @click="emits('goToRegister')"
              />
            </div>
          </div>
        </div>
        <VForm
          v-else
          :button="{
            label: $t('actions.signIn'),
            class: 'primary full-size',
            hotDisabled: false,
          }"
          :displayErrors="false"
          :displayErrorsOnSubmit="true"
          :callback="submit"
        >
          <template #form-body>
            <VField
              label="Adresse e-mail"
              type="email"
              placeholder="adresse@email.com"
              name="email"
              rules="required|email"
              v-model="state.email"
              icon="bi-at"
              :required="true"
            />
            <VField
              type="password"
              label="Mot de passe"
              placeholder="••••••••••••"
              name="password"
              rules="required|password"
              v-model="state.password"
              icon="bi-lock"
              :required="true"
            />
          </template>
          <template #form-error="{ errors }">
            <div
              v-if="Object.keys(errors).length > 0 || state.error"
              class="form-error small"
              v-text="getError('ERROR_AUTH_INVALID_CREDENTIALS')"
            />
          </template>
        </VForm>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import { storeToRefs } from "pinia";
import { getError } from "@/composables/error.js";
import { getImage } from "@/composables/getImage.js";
import Welcome from "./InviteWelcome.vue";
import CampaignConnect from "./CampaignConnect.vue";

const emits = defineEmits(["goToRegister", "continue", "setBackground"]);

const candidateStore = useCandidateStore();

const { invitation } = storeToRefs(candidateStore);

// Manage the showBigCampaign state
const showBigCampaign = ref(false);
const buttonPress = ref(false);

// Function to toggle the focus mode
const toggleFocus = () => {
  showBigCampaign.value = !showBigCampaign.value;
};

if(invitation.value.campaign.bg_image_id) {
  const imageBGUrl = getImage(invitation.value.campaign.bg_image_id);
  emits("setBackground", imageBGUrl);
}

const state = reactive({
  showLoginForm: false,
  isSubmit: false,
  error: null,
  email: "",
  password: "",
});

function connectPress() {
  buttonPress.value = true;
}

async function submit() {
  const loginAttempt = await candidateStore.login(state.email, state.password);

  if (loginAttempt.token) {
    state.error = null;
    emits("continue");
  } else {
    state.error = loginAttempt.key;
  }
}
</script>


<style>
.log_or_reg_main {
  display: flex;
  flex-direction: row;
}
</style>